import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Link = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/link">
        <g id="link">
          <path
            id="Vector"
            d="M10.9989 12.1667H9.99219C9.71885 12.1667 9.49219 11.94 9.49219 11.6667C9.49219 11.3934 9.71885 11.1667 9.99219 11.1667H10.9989C12.7455 11.1667 14.1655 9.74671 14.1655 8.00004C14.1655 6.25337 12.7455 4.83337 10.9989 4.83337H9.99885C9.72552 4.83337 9.49885 4.60671 9.49885 4.33337C9.49885 4.06004 9.71885 3.83337 9.99885 3.83337H10.9989C13.2989 3.83337 15.1655 5.70004 15.1655 8.00004C15.1655 10.3 13.2989 12.1667 10.9989 12.1667Z"
          />
          <path
            id="Vector_2"
            d="M5.9987 12.1667H4.9987C2.6987 12.1667 0.832031 10.3 0.832031 8.00004C0.832031 5.70004 2.6987 3.83337 4.9987 3.83337H5.9987C6.27203 3.83337 6.4987 4.06004 6.4987 4.33337C6.4987 4.60671 6.27203 4.83337 5.9987 4.83337H4.9987C3.25203 4.83337 1.83203 6.25337 1.83203 8.00004C1.83203 9.74671 3.25203 11.1667 4.9987 11.1667H5.9987C6.27203 11.1667 6.4987 11.3934 6.4987 11.6667C6.4987 11.94 6.27203 12.1667 5.9987 12.1667Z"
          />
          <path
            id="Vector_3"
            d="M10.6654 8.5H5.33203C5.0587 8.5 4.83203 8.27333 4.83203 8C4.83203 7.72667 5.0587 7.5 5.33203 7.5H10.6654C10.9387 7.5 11.1654 7.72667 11.1654 8C11.1654 8.27333 10.9387 8.5 10.6654 8.5Z"
          />
        </g>
      </g>
    </svg>
  );
};

Link.displayName = 'Link';
